"use client";

import { useEffect, useState } from "react";
import posthog from "posthog-js";
import { VIPPS_HURTIGKASSE_FLAG } from "./constants";

/**
 * Whether Vipps Hurtigkasse is on for this visitor, from PostHog. False until
 * the flags have loaded. Keep the rollout at 0 or 100 %, or targeted on a
 * person property: visitors without statistics consent get a new PostHog id
 * on every page load, so a percentage rollout would come and go for them.
 */
export function useVippsHurtigkasseFlag(): boolean {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    return posthog.onFeatureFlags(() => {
      setEnabled(posthog.isFeatureEnabled(VIPPS_HURTIGKASSE_FLAG) === true);
    });
  }, []);

  return enabled;
}
